export default {"src":"/_next/static/media/vuetifyjs.88928116.svg","height":293,"width":256,"blurWidth":0,"blurHeight":0};